import { ExtensionGroupOption } from 'src/app/pages/extension-register/models/extension-group-option.interface';
import { ExtensionOption } from 'src/app/pages/extension-register/models/extension-option.interface';

export enum ChipInputType {
   ExtensionGroup,
   Extension,
}
export interface ChipInputOption {
   id: number;
   type: ChipInputType;
   value: ExtensionGroupOption | ExtensionOption;
   extensionGroupSuperviseeId: number | null;
   supervisorExtensionId: number | null;
   extensionGroupId: number | null;
   extensionId: number | null;
   superviseeExtensionGroupId: number | null;
   extensionSuperviseeId: number | null;
   superviseeExtensionId: number | null;
   isDeleted: boolean;
}

export interface IncomingSuperviseeData {
   extensionSupervisees: Array<{
      extensionId: number;
      extensionSuperviseeId: number;
      name: string;
      number: number;
      superviseeExtensionId: number;
      supervisorExtensionId: number;
   }>;
   extensionGroupSupervisees: Array<{
      description: string;
      extensionGroupSuperviseeId: number;
      name: string;
      superviseeExtensionGroupId: number;
      supervisorExtensionId: number;
      extensionGroupId: number;
   }>;
}
